import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import {IMenuClass} from '../../../../../core/services/menu/menu.service';

interface IPageDO0066 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Do0066Controller(
            Menu: IMenuClass,
            MenuItemForage: IMenuItemForageClass,
            do0065Route:IRoute
    ) {
    const vm: IPageDO0066 = this;

    vm.multiOccurrenceOptions = {
    navigatePage: do0065Route.NAME,
    navigateParams: (rowData: any) =>
            (
              {  id : rowData.caecleint
              }
            ),
        fonctions: {
            rechercheCollapsable: false
        },
        colonnesVisibles: [
            {nom: 'caenumdoc', largeur: 115},
            {nom: 'caedatsou', largeur: 130},
            {nom: 'caenom', largeur: 158},
            {nom: 'caeprn', largeur: 158},
            {nom: 'caenummat', largeur: 158},
            {nom: 'eplnummat', largeur: 158},
            {nom: 'caeadrcou', largeur: 200},
            {nom: 'caesex_dsc', largeur: 90},
            {nom: 'caeflgimm', largeur: 135},
            {nom: 'nbrofa', largeur: 140},
            {nom: 'eplnomusu', largeur: 135},
            {nom: 'eplprnusu', largeur: 135}
        ]
    };
}
